export const PART_LAB = ['yes', 'no'];